<div class="grid-x">
    <ag-grid-angular [gridOptions]="gridOptions" [rowData]="expiringInsurancePolicies | async" class="data-grid " [attr.aria-label]="gridAriaLabel"></ag-grid-angular>
</div>
